import { ArrowLeft, Bell } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { NotificationSettingsSection } from "./SettingsPage";

export function NotificationSettingsPage() {
  const navigate = useNavigate();

  return (
    <div className="mx-auto max-w-4xl animate-fade-in space-y-6">
      <header>
        <button
          type="button"
          onClick={() => navigate("/settings")}
          className="mb-3 inline-flex items-center gap-1.5 text-sm font-semibold text-slate-500 transition hover:text-teal-700 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-teal-500 focus-visible:ring-offset-2"
        >
          <ArrowLeft className="h-4 w-4" />
          Back to settings
        </button>
        <div className="flex items-start gap-3">
          <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-teal-50 text-teal-700">
            <Bell className="h-5 w-5" />
          </span>
          <div>
            <h1 className="text-2xl font-bold tracking-tight text-slate-950 sm:text-3xl">
              Notification settings
            </h1>
            <p className="mt-1 text-sm text-slate-500 sm:text-base">
              Set the stock and expiry thresholds that should alert your team.
            </p>
          </div>
        </div>
      </header>

      <NotificationSettingsSection />
    </div>
  );
}

export default NotificationSettingsPage;
